export default "__VITE_ASSET__5841fac1__"